import { Component, SimpleChanges, ViewChildren, ElementRef, QueryList, ChangeDetectorRef, HostListener, ViewChild, Input, Output, EventEmitter, PLATFORM_ID, Inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormControl } from '@angular/forms';

import { ComponentBase } from '@framework/base/component';
import { TagViewModel } from '@modules/story/models/view-models';
import { Observable, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { CoreState } from '@app/store/core/states';
import { storySelector, storyStepSelector, storyBuilderSelector } from '@modules/story/store/selectors';
import { CreateTagInputApiModel } from '@modules/story/models/api-models/input';
import { storyStepActions, storyBuilderActions } from '@modules/story/store/actions';
import { ScrollbarComponent } from '@framework/components/scrollbar';
import { withLatestFrom, take } from 'rxjs/operators';
import { Actions, ofType } from '@ngrx/effects';
import { mediaDownloadAction, mediaRecordAction } from '@app/store/features/media/actions';
import { isPlatformBrowser } from '@angular/common';
@Component({
  selector: 'app-storyflow-card-tags-request',
  templateUrl: './storyflow-card-tags-request.component.html',
  styleUrls: ['./storyflow-card-tags-request.component.scss']
})
export class StoryflowCardTagsRequestComponent extends ComponentBase {
@Input() reduceHeight: boolean = false;
  @Input() companyId:any;
  @Input()  stepId:any
  @Input() inbound:boolean;
  @Input() inboundBuilder: boolean = false;
  @Output() closetagBox : EventEmitter<any> = new EventEmitter<any>();
  @ViewChildren('addTagInput', { read: ElementRef })

  addTagInput: QueryList<ElementRef>;
  @ViewChild(ScrollbarComponent)
  scrollbarControl: ScrollbarComponent;

  private maxSelectdTags: number = 5;
  private selectStoryCreating$: Observable<boolean>;
  private selectTagCreated$: Observable<TagViewModel>;
  private selectStepActive$: Observable<any>;
  private selectStepSelectedData$: Observable<any>;
  private selectInbound$: Observable<boolean>;
  private selectCompanyId$: Observable<number>;
  private createTagSuccessSubscription: Subscription;
  private selectStoryCreatingSubscription: Subscription;
  private selectTagCreatedSubscription: Subscription;
  private selectStepActiveSubscription: Subscription;
  private selectStepSelectedTagsDataSubscription: Subscription
  private selectStepSelectedPlayersData$: Observable<any>;
  private loadStepSuccessSubscription: Subscription;
  public form: UntypedFormGroup;
  public viewmodel = {
    isStoryCreating: false,
    isShowCreateTagErrorMsg: false,
    isTagCreating: false,
    inbound: false,
    companyId: 0,
    bacgroundHover: ''
  };
  public manageEventShake = {};
  public tagPagination = {
    pageIndex: 1,
    pageSize: 100,
    isAllowLoadMore: true
  };
  public stepActive: any = {};
  public dynamicObject = {};
  public selectedData: any = [];
  public tags: any[] = [];
  disableSubmit: boolean = false;
  mediaSubscription: Subscription;
  constructor(
    private store$: Store<CoreState>,
    private formBuilder: UntypedFormBuilder,
    private detector: ChangeDetectorRef,
    private actions$: Actions
  ) {
    super();

    this.initForm();


    this.selectStoryCreating$ = this.store$.select(storySelector.selectCreating);
    this.selectTagCreated$ = this.store$.select(storyStepSelector.selectCreatedTag);
    this.selectStepActive$ = this.store$.select(storyBuilderSelector.selectStepActive);
    this.selectStepSelectedData$ = this.store$.select(storyBuilderSelector.selectStoryStepSelected);
    this.selectInbound$ = this.store$.select(storyBuilderSelector.selectInbound);
    this.selectCompanyId$ = this.store$.select(storyBuilderSelector.selectCompanyId);
    this.selectStepSelectedPlayersData$ = this.store$.select(storyBuilderSelector.selectStoryStepSelectedPlayers);
  }

  // Lifecycle hooks
  protected onInit(): void {
    this.subscribe();
  }
  protected onDestroy(): void {
    this.unSubscribe();
  }
  protected onChanges(changes: SimpleChanges): void {


  }
  protected onDoCheck(): void {

  }
  protected onAfterContentInit(): void {

  }
  protected onAfterContentChecked(): void {

  }
  protected onAfterViewInit(): void {
     
    if(this.reduceHeight && !this.inboundBuilder){
      let bottomheight = $('#internal-story_menu').height();
      let topheigt = $('.site-header').height();
      let totalheight;
      if(bottomheight == 0 || bottomheight == undefined){
         totalheight = 153.781;
      }
      else{
        totalheight = bottomheight + 96;
      }
     
    $("#tag__height").css('height',"calc(100% - "+totalheight+"px)")
    }
    if(this.reduceHeight && this.inboundBuilder){
      let bottomheight = $('#external-story_menu').height();
      let topheigt = $('.site-header').height();
      let totalheight;
      if(bottomheight == 0 || bottomheight == undefined){
         totalheight = 153.786;
      }
      else{
        totalheight = bottomheight + 96;
      }
  
     
    $("#tag__height").css('height',"calc(100% - "+totalheight+"px)")
    }

  }
  protected onAfterViewChecked(): void {

  }
  protected validateAllFormFields(formGroup: UntypedFormGroup): void {

  }

  // Private functions

  private initForm() {
    this.form = this.formBuilder.group({
      tag: ['', Validators.compose([Validators.required, this.tagCustomValidate.bind(this)])]
    });
  }

  private subscribe() {
    this.selectStoryCreatingSubscription = this.selectStoryCreating$.subscribe((creating: boolean) => {
      this.viewmodel.isStoryCreating = creating;

      this.detector.detectChanges();
    });
    this.mediaSubscription = this.actions$.pipe(
      ofType<mediaDownloadAction.CheckDownloaf>(mediaDownloadAction.ActionTypes.CHECK_DOWNLOAD)
    ).subscribe((action: any) => {
        if(action.download){
          this.disableSubmit = true;
        }
        else{
          this.disableSubmit = false;
        }
      

    })
    this.selectTagCreatedSubscription = this.selectTagCreated$.subscribe((tag: TagViewModel) => {
      if (tag && this.viewmodel.isTagCreating === true) {
        this.selectedData = this.selectedData || [];
        // Do nothing if tag is existed
        if (this.selectedData.indexOf(tag.id) > -1) return;

        this.selectedData.push(tag.id);
   
        this.stepActive.tags.unshift(tag);

        this.addToObject(this.stepActive.id, this.selectedData);
   
        // this.viewmodel.isTagCreating = false;
        this.updateSelectedValues();
        this.resetForm();

        this.updateOutputData();
        this.viewmodel.isTagCreating = false;
      }
    });

    this.selectStepActiveSubscription = this.selectStepActive$.pipe(
      withLatestFrom(
        this.selectInbound$,
        this.selectCompanyId$,
        this.selectStepSelectedData$
      )
    ).subscribe(([stepActive, inbound, companyId, selectedData]) => {
      this.stepActive = stepActive || {};
      this.tags = this.stepActive.tags || [];
      this.viewmodel.bacgroundHover = this.getHoverBackgroundColor(this.stepActive.color);

      this.viewmodel.inbound = inbound;
      this.viewmodel.companyId = companyId;

      this.selectedData = selectedData;
      if(this.selectedData){
        this.loadTagsData();
      }
      this.autoFocus();
      this.form.reset();
      this.scrollbarControl.scrollToTop();
    });

    this.loadStepSuccessSubscription = this.actions$.pipe(
      ofType<storyStepActions.LoadSuccess>(storyStepActions.ActionTypes.LOAD_SUCCESS)
    ).subscribe((result) => {
      if (result.data) {
        var data = result.data.find(tag => tag.id == this.stepActive.id)
        if( data && data.tags != null){
          data.tags.forEach((tag)=>{
            if(!this.stepActive.tags.find(tagdata => tagdata.id == tag.id)){
             if((tag['is_active'] != 0))
             this.stepActive.tags.unshift(tag);
            }
          })
        }

        this.updateSelectedValues();
      }
    });
   


   
    // this.selectStepSelectedPlayersData$.subscribe(selectedPlayers => {
    //   this.updateSelectedValues();
    //   this.loadTagsData();
    // })
  
  }

  private loadTagsData(){
    this.store$.dispatch(new storyStepActions.Load(this.companyId,this.viewmodel.inbound, '', true));
  }
  private unSubscribe() {
    this.selectStoryCreatingSubscription.unsubscribe();
    this.selectTagCreatedSubscription.unsubscribe();
    this.selectStepActiveSubscription.unsubscribe();
  }

  private updateSelectedValues() {
    
    this.tags.forEach(tag => {
      tag.checked = this.selectedData && this.selectedData.indexOf(tag.id) > -1
    });

    
    this.tags.forEach((item,i)=>{
      if(item.checked){
        let data;
        data = item;
        this.tags.splice(i,1);
        this.tags.unshift(data);

      }
    })

  
    this.checkToDisableForm();

    this.detector.detectChanges();
  }

  private autoFocus() {
    setTimeout(() => {
      this.addTagInput.toArray()[0].nativeElement.focus();
    }, 500);
  }

  private resetForm() {
    this.form.reset();
  }

  private updateOutputData() {
    this.updateData();
  }

  private tagCustomValidate(control: UntypedFormControl) {
    let value = control.value;
    if (!value || value.trim().length === 0) {
      return 'String empty';
    }
    return null;
  }

  // Step 8: Method to update step completion for timeline coloring
  private updateStepCompleted() {
    // Get current completed steps from store
    this.store$.select(storyBuilderSelector.selectStepCompleted).pipe(take(1)).subscribe(completedSteps => {
      const isCompleted = this.selectedData && this.selectedData.length > 0;
      const stepId = this.stepActive.id;
      
      let updatedCompletedSteps = [...completedSteps];
      
      if (isCompleted && !updatedCompletedSteps.includes(stepId)) {
        // Add step to completed list
        updatedCompletedSteps.push(stepId);
        // Dispatch the updated completed steps
        this.store$.dispatch(new storyBuilderActions.UpdateStepsCompleted(updatedCompletedSteps));
      } else if (!isCompleted && updatedCompletedSteps.includes(stepId)) {
        // Remove step from completed list
        updatedCompletedSteps = updatedCompletedSteps.filter(id => id !== stepId);
        // Dispatch the updated completed steps
        this.store$.dispatch(new storyBuilderActions.UpdateStepsCompleted(updatedCompletedSteps));
      }
    });
  }

  // Public functions
  public selectItem(tag: TagViewModel) {
    this.selectedData = this.selectedData || [];

    if (tag.checked === true) {
        this.selectedData.push(tag.id);
    } else {
        const index = this.selectedData.findIndex(f => f === tag.id);
        if (index !== -1) {
            this.selectedData.splice(index, 1);
        }
    }

    // Dispatch action
    if (!this.disableSubmit) {
        setTimeout(() => {
            this.store$.dispatch(new mediaRecordAction.CheckRecord(false));
        }, 1000);
    } else {
        this.store$.dispatch(new mediaRecordAction.CheckRecord(true));
    }

    this.checkToDisableForm();

    // Update the dynamic object
    this.updateOutputData();
    this.addToObject(this.stepActive.id, this.selectedData);
    
    // Step 8: Update step completion for timeline coloring
    this.updateStepCompleted();
}

addToObject(key: number, value: number[]) {
    // Check if the key already exists in the object
    if (!this.dynamicObject[key]) {
        this.dynamicObject[key] = [];
    }

    // Add each value in `value` (which is selectedData) if not already present
    value.forEach(val => {
        if (!this.dynamicObject[key].includes(val)) {
            this.dynamicObject[key].push(val);
        }
    });

    this.store$.dispatch(new storyStepActions.AddToObject(this.dynamicObject))
    console.log(this.dynamicObject);
}

  public checkDisabled(tag: any) {
    
    return this.selectedData && this.selectedData.length >= this.maxSelectdTags && !tag.checked;
  }

  public checkToDisableForm() {
    if (this.selectedData && this.selectedData.length >= this.maxSelectdTags) {
      this.form.disable();
    } else {
      this.form.enable();
    }
  }

  public loadTags() {
    const tags = this.tags.filter(tag => !this.form.controls.tag.value || tag.name.toLocaleLowerCase().indexOf(this.form.controls.tag.value.toLocaleLowerCase()) > -1 || tag.checked);

    const startIndex = 0;
    const endIndex = this.tagPagination.pageIndex * this.tagPagination.pageSize

    const pagedTags = tags.slice(startIndex, endIndex);

    this.tagPagination.isAllowLoadMore = pagedTags.length < tags.length;
    if(this.form.controls.tag.value){
      return pagedTags
    }
    else{
      return pagedTags.filter(tag =>  (tag.is_active != 2 && tag.is_active != 0) || (tag.is_active == 2 && tag.checked) || (tag.is_active == 0 && tag.checked));
    }
    
  }

  public addTag() {
    
    if (!this.form.valid) return;
     if(this.isdisabled)  return;
     
    this.viewmodel.isShowCreateTagErrorMsg = false;
    if (this.selectedData && this.selectedData.length === this.maxSelectdTags) {
      this.viewmodel.isShowCreateTagErrorMsg = true;
    }

    this.viewmodel.isTagCreating = true;

    let createTagModel = new CreateTagInputApiModel();
    createTagModel.name = this.form.controls.tag.value;
    createTagModel.resource_id = this.stepActive.id;
    createTagModel.resource_type = 'storystep';
    createTagModel.payload = { cid: this.companyId, inbound: this.viewmodel.inbound };

    this.store$.dispatch(new storyStepActions.CreateTag(this.stepActive.id, createTagModel));
    // this.store$.dispatch( new mediaRecordAction.CheckRecord(false))
    if(!this.disableSubmit){
      setTimeout(()=>{
        this.store$.dispatch(new mediaRecordAction.CheckRecord(false))
      },1000)
    }
    else{
      this.store$.dispatch(new mediaRecordAction.CheckRecord(true))
    }
  }

  public tagItemClick(tagItem) {
    if (!this.checkDisabled(tagItem)) return;

    this.manageEventShake[tagItem.id] = true;
    setTimeout(() => {
      this.manageEventShake[tagItem.id] = false;
    }, 500); // 5s

  }

  public tagTrackByFn(index, tagItem) {
    return tagItem.id;
  }

  public scrollReachEnd($event) {
    if (!this.tagPagination.isAllowLoadMore) return;
    this.tagPagination.pageIndex += 1;
    this.detector.detectChanges();
  }

  public updateData() {
    
    if (!this.stepActive) return;

    this.store$.dispatch(new storyBuilderActions.UpdateStoryStepSelected(this.stepActive.id, this.selectedData));
  }

  public handleComKeyEnter(event) {
    
    const isCompleted = this.selectedData && this.selectedData.length > 0;
    if (isCompleted) {
      // Goto next step
      this.store$.dispatch(new storyBuilderActions.GotoNextStep());
    }
  }

  public exceptHandleComKeyEnter(event) {
    event.stopPropagation();
  }

  public getHoverBackgroundColor(hex) {
    const rbg = this.hexToRgb(hex);
    if (!rbg) return '';
    const style = `linear-gradient(to bottom, ${hex} 0%, rgba(${rbg.r}, ${rbg.g}, ${rbg.b}, 0) 100%)`;
    return style;
  }
  ChecktheTagcount()
  {
    var tags = this.loadTags()
    var count =0;
    tags.forEach((item,i)=>{
      if(item.checked)
      {
        count +=1;
      }
    })
    return count
  }
  public hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  }

  closetag()
  {
    this.closetagBox.emit('closetag')
  }

  get isdisabled() : boolean {
     
    if(this.form.controls.tag.value){

      if(this.tags.filter(tag => tag.name.toLocaleLowerCase() == this.form.controls.tag.value.toLocaleLowerCase()).length){
        return true;
      }
      else{
        return false;
      }
    }
    else{
      return true;
    }

  }

  }
